import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class SystemRunModel extends Model {
  static reducer(action, SystemRunModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.SystemRun.schema:
        action.payload.forEach((payload) => {
          const dbData = SystemRunModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          SystemRunModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
SystemRunModel.modelName = "SystemRunModel";

SystemRunModel.fields = {
  id: attr(),
};

export default SystemRunModel;